import React from 'react';
import Videos from "./Videos";

const Home = () => {
  return <Videos />;
};

export default Home;
